<template>
     <div class="cart-summary" v-if="cartCount()">
          <p class="text-right"><b>{{vignetteCount()}} {{tollCount()}}, {{ uclower($t('total')) }} = {{cartTotal()}} {{ $tc('currency', cartTotal()) }}<span v-if="cartSMSTotal() > 0">, {{ uclower($t('total_sms')) }} = {{ cartSMSTotal() }} {{ $tc('currency', cartSMSTotal()) }}</span></b></p>
     </div>
     <div v-else>
          <p>{{ $t('cart')['empty'] }}</p>
     </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
     name: 'CartSummary',
     data: function() {
         return {
             vignettes: false
         }
     },
     computed: {
         ...mapState('cart', [
             'cart'
         ]),
     },
     props: {
     },
     methods: {

         ...mapGetters('cart', [
             'getCart',
             'cartCount',
             'cartTotal',
             'cartSMSTotal'
         ]),

          vignetteCount() {
               var key = "vignette";
               var vignetteOnlyArray = this.cart.filter((obj) => obj.type == key);
               if (vignetteOnlyArray.length == 0) {
                    return "";
               }
               else {
                    this.vignettes = true;

                    return vignetteOnlyArray.length + (vignetteOnlyArray.length > 1 ? ' ' + this.$tc('vignette', 2) : ' ' + this.$tc('vignette', 1));
               }
          },

          tollCount() {
               var key = "toll";
               var tollOnlyArray = this.cart.filter((obj) => obj.type == key);

               var passesTotal = 0;
               for (var i = 0; i < tollOnlyArray.length; i++) {
                    passesTotal += tollOnlyArray[i].quantity;
               }

               if (this.vignettes && tollOnlyArray.length > 0) {
                    return this.$t('and') + " " + passesTotal + (passesTotal > 1 ? ' ' + this.$tc('passing', 2) : ' ' + this.$tc('passing', 1));
               }
               else if (!this.vignettes && tollOnlyArray.length > 0) {
                    return passesTotal + (passesTotal > 1 ? ' ' + this.$tc('passing', 2) : ' ' + this.$tc('passing', 1));
               }
               else {
                    return "";
               }
          },
     }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
     .cart-summary{
          margin: 40px 0;
     }
</style>
